import appLogger from "../utils/app-logger";
import { apiService } from "../services/base-api-service";
import { endPoints, getUserServiceEndPoint } from "../services/api-constants";
import { getJWTServiceToken, readCookie, getAuthHeader } from "../utils/helpers";

class UserService {
  UserService(url) {
    return getUserServiceEndPoint(url);
  }
  createUser(data) {
    appLogger.log("inside createUser ");
    const createUserEndpoint = this.UserService(`${endPoints.userService.CREATE_USER}`);
    return apiService.post(createUserEndpoint, data);
  }
  createExternalUser(data) {
    appLogger.log("inside createExternalUser ");
    const createUserEndpoint = this.UserService(`${endPoints.userService.CREATE_EXTERNAL_USER}`);
    return apiService.post(createUserEndpoint, data);
  }
  loginUser(data) {
    appLogger.log("inside loginUser ");
    const loginUserEndpoint = this.UserService(`${endPoints.userService.CREATE_USER}`);
    return apiService.post(loginUserEndpoint, data);
  }
  updatePassword(data) {
    appLogger.log("inside updatePassword ");
    const updateUserPwdEndpoint = this.UserService(`${endPoints.userService.UPDATE_PWD}`);
    return apiService.post(updateUserPwdEndpoint, data, getAuthHeader());
  }
  resetPasswordAtempt(data) {
    appLogger.log("inside resetPasswordAtempt ");
    const resetPasswordEndpoint = this.UserService(`${endPoints.userService.RESET_PWD}`);
    return apiService.post(resetPasswordEndpoint, data);
  }
  forgotPasswordAtempt(data) {
    appLogger.log("inside forgotPasswordAtempt ");
    const forgotPasswordEndpoint = this.UserService(`${endPoints.userService.FORGOT_PWD}`);
    return apiService.patch(forgotPasswordEndpoint, data);
  }
  getUserProfile(userGuid) {
    appLogger.log("inside getIsPremiumByUserGuid");
    const serviceEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_PROFILE.replace(":userGuid", userGuid)}`,
    );
    return apiService.get(serviceEndpoint, null, getAuthHeader());
  }
  getUserProfileByServiceToken(userGuid) {
    const headers = { Authorization: "Bearer " + getJWTServiceToken() };
    appLogger.log("inside getIsPremiumByUserGuid");
    const serviceEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_PROFILE.replace(":userGuid", userGuid)}`,
    );
    return apiService.get(serviceEndpoint, null, headers);
  }
  signinAsAdmin(data) {
    appLogger.log("inside signinAsAdmin ");
    const signinAsAdminEndpoint = this.UserService(`${endPoints.userService.SIGNIN_AS_ADMIN}`);
    return apiService.post(signinAsAdminEndpoint, data);
  }
  getUserByUserName(userName, tenantGroupId = "") {
    appLogger.log("inside getUserByUserName ");
    const getUserByUserNameEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_USERNAME.replace(":username", userName).replace(
        ":tenantGroupId",
        tenantGroupId,
      )}`,
    );
    return apiService.get(getUserByUserNameEndpoint, null, getAuthHeader());
  }
  getUserByEmail(email, tenantGroupId = "") {
    appLogger.log("inside getUserByEmail ");
    const getUserByEmailEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_EMAIL.replace(":email", email).replace(":tenantGroupId", tenantGroupId)}`,
    );
    return apiService.get(getUserByEmailEndpoint, null, getAuthHeader());
  }
  getUserByUserGuid(userGuid, tenantGroupId = "") {
    appLogger.log("inside getUserByUserGuid ");
    const getUserByUserGuidEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_GUID.replace(":guid", userGuid).replace(":tenantGroupId", tenantGroupId)}`,
    );
    return apiService.get(getUserByUserGuidEndpoint, null, getAuthHeader());
  }

  getUserObject() {
    appLogger.log("inside getUserObject ");
    const getUserObkectEndpoint = this.UserService(`${endPoints.userService.GET_USER_OBJECT}`);
    return apiService.get(getUserObkectEndpoint, null, getAuthHeader());
  }
  loginAttempt(data) {
    appLogger.log("inside loginAttempt ");
    const loginAttemptEndpoint = this.UserService(`${endPoints.userService.LOGIN_ATTEMPT}`);
    return apiService.post(loginAttemptEndpoint, data);
  }
  getCaptchaScore(greToken, portal) {
    appLogger.log("inside getCaptchaScore ");
    const getCaptchaScoreEndpoint = this.UserService(
      `${endPoints.userService.RECAPTCHA_SCORE.replace(":greToken", greToken).replace(":portal", portal)}`,
    );
    return apiService.get(getCaptchaScoreEndpoint);
  }
  validateLgctExpiry(token) {
    const getValidateLgctTokenEndPoint = this.UserService(
      `${endPoints.userService.VALIDATE_LGCT_EXPIRY.replace(":token", token)}`,
    );
    return apiService.get(getValidateLgctTokenEndPoint);
  }
  saveUserAddress(userAddress) {
    const saveUserAddressEndPoint = this.UserService(`${endPoints.userService.SAVE_USER_ADDRESS}`);
    return apiService.post(saveUserAddressEndPoint, userAddress, getAuthHeader());
  }
  getIp2Connect(ipAddress) {
    const saveUserAddressEndPoint = this.UserService(
      `${endPoints.userService.IP_2_CONNECT.replace(":ipaddress", ipAddress)}`,
    );
    return apiService.get(saveUserAddressEndPoint);
  }
  updateHasView(data, userGuid) {
    const getUpdateProfileEndpoint = this.UserService(
      `${endPoints.userService.UPDATE_HAS_VIEW.replace(":userGuid", userGuid)}`,
    );
    return apiService.put(getUpdateProfileEndpoint, data, getAuthHeader());
  }
  validateGuestToken(data) {
    const getValidateGuestTokenEndpoint = this.UserService(`${endPoints.userService.VALIDATE_GUEST_TOKEN}`);
    return apiService.post(getValidateGuestTokenEndpoint, data, getAuthHeader());
  }
  addSingleDocumentIntoDocProfile(userGuid, data) {
    const getDocumentProfileEndPoint = this.UserService(
      `${endPoints.userService.DOCUMENT_UPDATE.replace(":userGuid", userGuid)}`,
    );
    return apiService.post(getDocumentProfileEndPoint, data, getAuthHeader());
  }
  getUser(userGuid) {
    appLogger.log("inside getUserObject ");
    const getUserEndpoint = this.UserService(`${endPoints.userService.USER.replace(":userGuid", userGuid)}`);
    return apiService.get(getUserEndpoint, null, getAuthHeader());
  }

  initiateVerification(data) {
    const getUserEndpoint = this.UserService(`${endPoints.userService.CONTACT_VERIFICATION}`);
    return apiService.post(getUserEndpoint, data, getAuthHeader());
  }

  VerifyCaptcha(recaptchaScoreRequest, domain) {
    const getCaptchaEndpoint = this.UserService(`${endPoints.userService.VERIFY_CAPTCHA.replace(":portal", domain)}`);
    return apiService.post(getCaptchaEndpoint, recaptchaScoreRequest, getAuthHeader());
  }
  updatePhoneNumber(data) {
    const getUpdateProfileEndpoint = this.UserService(`${endPoints.userService.UPDATE_PHONE_NUMBER}`);
    return apiService.put(getUpdateProfileEndpoint, data, getAuthHeader());
  }

  getUserProfileByGuid(userGuid, isAbridged) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    if (isAbridged == true) {
      const getUserProfileAbridgedEndPoint = this.UserService(
        `${endPoints.userService.GET_USER_PROFILE_ABRIDGED.replace(":userguid", userGuid)}`,
      );
      return apiService.get(getUserProfileAbridgedEndPoint, null, headers);
    } else {
      const getUserProfileEndPoint = this.UserService(
        `${endPoints.userService.GET_USER_PROFILE.replace(":userguid", userGuid)}`,
      );
      return apiService.get(getUserProfileEndPoint, null, headers);
    }
  }
  onboardOrgUserRole(data) {
    const onboardOrgUserRoleEndpoint = this.UserService(`${endPoints.userService.ONBOARD_ORG_USER_ROLE}`);
    return apiService.post(onboardOrgUserRoleEndpoint, data, getAuthHeader());
  }
}

export default new UserService();
